/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
} from './CredentialType';
import type { PasswordCredentialParams } from './PasswordCredentialParams';
import {
    PasswordCredentialParamsFromJSON,
    PasswordCredentialParamsFromJSONTyped,
    PasswordCredentialParamsToJSON,
} from './PasswordCredentialParams';

/**
 * 
 * @export
 * @interface ExportedPasswordCredential
 */
export interface ExportedPasswordCredential {
    /**
     * The ID of the credential
     * @type {string}
     * @memberof ExportedPasswordCredential
     */
    id: string;
    /**
     * The time when the credential was last used to authenticate successfully
     * @type {Date}
     * @memberof ExportedPasswordCredential
     */
    last_used?: Date;
    /**
     * 
     * @type {CredentialType}
     * @memberof ExportedPasswordCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {PasswordCredentialParams}
     * @memberof ExportedPasswordCredential
     */
    params: PasswordCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof ExportedPasswordCredential
     */
    label?: string;
}

/**
 * Check if a given object implements the ExportedPasswordCredential interface.
 */
export function instanceOfExportedPasswordCredential(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;

    return isInstance;
}

export function ExportedPasswordCredentialFromJSON(json: any): ExportedPasswordCredential {
    return ExportedPasswordCredentialFromJSONTyped(json, false);
}

export function ExportedPasswordCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedPasswordCredential {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'last_used': !exists(json, 'last_used') ? undefined : (new Date(json['last_used'])),
        'type': CredentialTypeFromJSON(json['type']),
        'params': PasswordCredentialParamsFromJSON(json['params']),
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function ExportedPasswordCredentialToJSON(value?: ExportedPasswordCredential | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'last_used': value.last_used === undefined ? undefined : (value.last_used.toISOString()),
        'type': CredentialTypeToJSON(value.type),
        'params': PasswordCredentialParamsToJSON(value.params),
        'label': value.label,
    };
}

